import React, { useEffect, useState } from "react";
import Icon from "../../assets/Icon";
import Footer from "../Footer";
import FeedbackEndInterview from "./FeedbackEndInterview";
import "../../styles/endInterview.css";
import WebUtils from "../utils/WebUtils";
import { completionInterviewGetApi } from "../../api";
import Loader from "../Loader";
import { useLocation } from "react-router-dom";
import Utils from "../utils/Utils";

function InterviewCompleted() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const interviewId = queryParams.get("interviewId");

  const [loading, setLoading] = useState();
  const [completionData, setCompletionData] = useState({
    candidateReviewExist: null,
  });
  // const [completionData, setCompletionData] = useState();

  const getCompletion = () => {
    setLoading(true);
    const url = `${completionInterviewGetApi}?interviewId=${interviewId}`;

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setCompletionData(result.data.data);
          // console.log(result.data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getCompletion();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className=" login-landing-page min-h-screen bg-primaryBg text-primaryWhite px-5 lg:px-8 py-2 flex flex-col justify-between items-center">
        <p className="py-2 w-full">
          {completionData?.whiteLabelingRequired ? (
            <img
              alt="logo"
              src={completionData?.whiteLabelingLink}
              className="h-[55px] py-1"
              onError={(e) => {
                e.target.onerror = null; // Prevents infinite loop in case the fallback fails
                e.target.style.display = "none"; // Hides the broken image
                e.target.nextSibling.style.display = "block"; // Shows the default icon
              }}
            />
          ) : (
            <Icon type="hire-logo" width="100" height="45" />
          )}
        </p>
        <div className="w-full">
          <p className="text-3xl font-semibold text-center">
            <span className="text-[#F79009]">{completionData?.jobTitle}</span> @
            {completionData?.companyName}
          </p>
          <p className="text-[.9rem] text-[#53A0F8] text-center my-2">
            {interviewId}
          </p>
          <div className="flex  flex-wrap justify-center text-center  gap-4 ">
            <div className="text-[#FCFCFD] text-[0.96rem] flex items-center gap-[0.45rem]  flex-wrap justify-center ">
              <Icon type="clock" color="white" width="16" height="16" />
              <span className="text-gray-200"> Duration:</span>
              <span className="font-semibold">
                {Utils.convertSecondsToTime(completionData?.interviewTimer)}
              </span>
            </div>
            <div className="text-[#FCFCFD] text-[0.96rem] flex items-center gap-[0.45rem] flex-wrap">
              <Icon type="clock" color="white" width="16" height="16" />
              <span className="text-gray-200">Timestamp:</span>
              <span className="font-semibold">
                {completionData?.interviewCompletionTimeStamp
                  ? Utils.converToDateMonthYear(
                      completionData.interviewCompletionTimeStamp
                    )
                  : "N/A"}
              </span>
            </div>
          </div>
          <div className="text-center w-full mt-4">
            Assessment Status:{" "}
            <span className="text-green-400 font-semibold"> Completed </span>
          </div>
        </div>
        {completionData?.candidateReviewExist === false && (
          <FeedbackEndInterview
            interviewId={interviewId}
            setLoading={setLoading}
            setCompletionData={setCompletionData}
          />
        )}
        <Footer />
      </div>
    </>
  );
}

export default InterviewCompleted;
